import "../styles/default.scss";

import classNames from "classnames";
import React from "react";

import AlertManagementSwitchersAbstract from "../../../../../abstract/AlertManagementSwitchersAbstract";
import withTranslations from "../../../../../hocs/withTranslations";
import { resolveAlertSettingsRowLabel } from "../../../../../lib/notifications/resolveAlertSettingsRowLabel";
import SquaberTooltip from "../../SquaberTooltip";
import { Switch } from "../../Typography";

class AlertManagementSwitchers extends AlertManagementSwitchersAbstract {
  handleChange(element, value) {
    const { onElementChange } = this.props;

    element.status = value;

    onElementChange(element);
  }

  getElement({ element, isHeader }) {
    const { translate, translationExists } = this.props;
    const { type, value, category } = element;

    if (type !== "description" && type !== "switcher") {
      return null;
    }

    switch (type) {
      case "switcher": {
        const label = translate(element.label);
        const isDisabled = element.disabled || element.globallyDisabled;
        const checked = element.globallyDisabled ? false : value;

        return (
          <React.Fragment>
            <span
              className={classNames({
                "switch-wrapper": true,
                disabled: isDisabled,
                "globally-disabled": element.globallyDisabled
              })}
            >
              <div className="switcher-form-control">
                <Switch
                  checked={checked}
                  disabled={isDisabled}
                  aria-label={label}
                  onChange={nextChecked => {
                    this.handleChange(element, nextChecked);
                  }}
                />
                <span className="switcher-label">{label}</span>
              </div>
            </span>
            {element.globallyDisabled ? (
              <span className="globally-disabled-notice">
                {translate("This setting is disabled globally")}
              </span>
            ) : null}
          </React.Fragment>
        );
      }
      case "description":
      default: {
        const label = resolveAlertSettingsRowLabel({
          category,
          value,
          translate,
          translationExists
        });

        if (isHeader) {
          return <span className="option-description">{label}</span>;
        }

        return (
          <span className="option-description">
            {label}{" "}
            {category ? (
              <SquaberTooltip title={`tooltip_notifications_${category}`}>
                <i className="fal fa-info-circle"></i>
              </SquaberTooltip>
            ) : null}
          </span>
        );
      }
    }
  }

  render() {
    const { disabled } = this.props;
    const { processedElements } = this.state;

    return (
      <div
        className={classNames({
          "alert-management-switchers": true,
          disabled
        })}
      >
        {processedElements.map((group, index) => (
          <div className="switcher-group" key={index}>
            {group.map((element, key) => (
              <div className="switcher-element" key={key}>
                {this.getElement({ element, isHeader: index === 0 })}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
}

export default withTranslations(AlertManagementSwitchers);
